import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Grid } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import "../MembershipPage.css";
import { withRouter } from "react-router-dom";
import HgSuperPayAddonSection from "./HgSuperPayAddonSection";
import { hgStripe } from "../StripeConfig.js";
import ConfirmationModal from "../../../components/modal/ConfirmationModal";
import MembershipPlanCard from "./MembershipPlanCard";
import MembershipFAQ from "./MembershipFAQ";
import BusinessIcon from "@material-ui/icons/Business";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import StarIcon from "@material-ui/icons/Star";

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
});

@inject("userStore", "profileStore", "hgBillingStore")
@withRouter
@observer
class SingleVenueBilling extends Component {
    constructor(props) {
        super(props);
    }

    state = {
        toggleModal: false
    };

    selectPlan = (value, type, isReturn) => {
        if (isReturn) return;
        this.props.selectPlan(value, type);
    }

    selecFreePlan = () => {
        this.props.selecFreePlan();
    }

    handleOpenModal = (isReturn) => {
        if (isReturn) return;
        this.setState({ toggleModal: true });
    }

    handleCloseModal = () => {
        this.setState({
            ...this.state,
            toggleModal: false
        });
    }

    render() {
        const { billingAccess } = this.props.hgBillingStore;

        var isSingleVenueFree = !billingAccess ? true : false || billingAccess.isFreePlan || billingAccess?.priceId === hgStripe.pricing.singleVenueFreeMembershipMonth;
        var isSingleVenueBasicMonthly = billingAccess?.priceId === hgStripe.pricing.singleVenueMembershipMonth || billingAccess?.priceId === hgStripe.pricing.singleVenueMonthlyLegacy;
        var isSingleVenueBasicPerGigs = billingAccess?.priceId === hgStripe.pricing.singleVenueMembershipPerGigBilledMonthly;
        var isSingleVenueProMonthly = billingAccess?.priceId === hgStripe.pricing.singleVenueProMembershipMonth;
        var isSingleVenueProPerGigs = billingAccess?.priceId === hgStripe.pricing.singleVenueProMembershipPerGigBilledMonthly;
        var priceIdExisted = billingAccess?.priceId ? true : false;
        var isEssential = billingAccess?.isBasicPlan && !priceIdExisted;
        var isProPlan = billingAccess?.isProPlan && !priceIdExisted;

        const freeFeatures = [
            "Create & manage your venue profile",
            "Up to 8 bookings per month",
            "Unlimited staff with role-based permissions",
            "Act roster management incl. venue favourites",
            "Act availability visibility",
            "Integrated worksheets & contracts",
            "Cancellation workflows",
            "Automated artist invoicing",
            "Spend vs budget reporting"
        ];

        const essentialsFeatures = [
            "Unlimited bookings",
            "Invite agents to manage your entertainment",
            "Automated gig promotion - website & screens",
            "Social post management for both live events and general social posts"
        ];

        const proFeatures = [
            "Accounting Package Integrations including XERO & MYOB (Quickbooks coming soon)"
        ];

        const singleVenueFAQs = [
            {
                question: "Can I change my plan at any time?",
                answer: "Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately and we'll prorate any billing adjustments."
            },
            {
                question: "What happens to my bookings if I downgrade?",
                answer: "All your existing bookings remain intact when you downgrade. However, if you move to the Free plan, you'll be limited to 8 bookings per month going forward. Any bookings already confirmed will not be affected."
            },
            {
                question: "How does Pay As You Go billing work for venues?",
                answer: "With Pay As You Go, you're charged $15 per completed booking (or $19 on the Pro plan). The charge is applied to your saved payment method at the end of each month, so you only pay for what you use."
            },
            {
                question: "What's the difference between Pay As You Go and Monthly for venues?",
                answer: "Pay As You Go suits venues with lower or variable booking volumes — you pay per completed booking with no ongoing commitment. Monthly gives you unlimited bookings for a fixed fee ($99 Essentials / $149 Pro), which is better value if you book entertainment regularly."
            },
            {
                question: "What accounting integrations are available on the Pro plan?",
                answer: "The Pro plan includes integrations with XERO and MYOB, with QuickBooks coming soon. These let you sync your entertainment spend directly into your accounting package."
            }
        ];

        return (
            <Fragment>
                <div className="membership-container">
                    <Grid container>
                        <Grid item xs={12}>
                            <div className="membership-grid">
                                <MembershipPlanCard
                                    planType="free"
                                    planName="Free"
                                    tagline="Get started with the basics"
                                    icon={<BusinessIcon style={{ fontSize: 24 }} />}
                                    features={freeFeatures}
                                    isFreePlan={true}
                                    isCurrentPayg={isSingleVenueFree}
                                    isCurrentMonthly={isSingleVenueFree}
                                    onSelectFree={() => this.handleOpenModal(isSingleVenueFree)}
                                />

                                <MembershipPlanCard
                                    planType="essentials"
                                    planName="Essentials"
                                    tagline="Everything in Free plus:"
                                    icon={<TrendingUpIcon style={{ fontSize: 24 }} />}
                                    features={essentialsFeatures}
                                    paygPrice="$15"
                                    monthlyPrice={!isSingleVenueBasicMonthly && isEssential ? "Free" : "$99"}
                                    isCurrentPayg={isSingleVenueBasicPerGigs}
                                    isCurrentMonthly={isSingleVenueBasicMonthly || (!isSingleVenueBasicMonthly && isEssential)}
                                    onSelectPayg={() => this.selectPlan(hgStripe.pricing.singleVenueMembershipPerGigBilledMonthly, 0, isSingleVenueBasicPerGigs)}
                                    onSelectMonthly={() => this.selectPlan(hgStripe.pricing.singleVenueMembershipMonth, 1, isSingleVenueBasicMonthly)}
                                />

                                <MembershipPlanCard
                                    planType="pro"
                                    planName="Pro"
                                    tagline="Everything in Essentials plus:"
                                    icon={<StarIcon style={{ fontSize: 24 }} />}
                                    features={proFeatures}
                                    paygPrice="$19"
                                    monthlyPrice={!isSingleVenueProMonthly && isProPlan ? "Free" : "$149"}
                                    isCurrentPayg={isSingleVenueProPerGigs}
                                    isCurrentMonthly={isSingleVenueProMonthly || (!isSingleVenueProMonthly && isProPlan)}
                                    onSelectPayg={() => this.selectPlan(hgStripe.pricing.singleVenueProMembershipPerGigBilledMonthly, 0, isSingleVenueProPerGigs)}
                                    onSelectMonthly={() => this.selectPlan(hgStripe.pricing.singleVenueProMembershipMonth, 1, isSingleVenueProMonthly)}
                                    highlighted={true}
                                />
                            </div>

                            <div style={{ padding: "0 0 8px" }}>
                                <HgSuperPayAddonSection />
                            </div>
                            <MembershipFAQ faqItems={singleVenueFAQs} />
                        </Grid>
                    </Grid>
                </div>

                <ConfirmationModal
                    open={this.state.toggleModal}
                    title={"Select Free Plan"}
                    message={`Are you sure you want to select the free plan?`}
                    closeHandler={this.handleCloseModal}
                    confirmationHandler={this.selecFreePlan}
                    declineHandler={this.handleCloseModal}
                    confirmationLabel="Confirm"
                />
            </Fragment>
        );
    }
}

export default withStyles(styles)(SingleVenueBilling);
